<template>
  <div class="purchase">
    <global-nav></global-nav>
    <div class="content-wrapper">
      <p class="title">核对并确认订单</p>
      <div class="info-wrapper">
        <p class="heading">学员信息<span class="more">请仔细核对信息，上课前，您将通过手机号接收消息提醒。</span></p>
        <div class="userinfo">
          <span class="text">姓名：{{decodeURIComponent(userinfo.uname)}}</span>
          <span class="text" style="margin-left:35px;">手机号：{{decodeURIComponent(userinfo.phone)}}</span>
          <span class="text" style="margin-left:35px;">学生课堂姓名：</span>
          <span class="text">{{decodeURIComponent(username)}}</span>
        </div>
        <p class="heading">订单信息</p>
        <div class="classinfo-wrapper" v-if="courseinfo!==null&&classinfo!==null">
          <div class="left">
            <p class="heading">课程信息</p>
            <div class="img-wrapper">
              <img
                :src="imgprefix+courseinfo.faceimg"
                alt="faceimg"
                width="120"
                height="80">
              <div class="courseinfo-wrapper">
                <p class="heading">{{decodeURIComponent(courseinfo.lessonname)}}</p>
                <p class="type">{{decodeURIComponent(courseinfo.typename)}}</p>
                <div class="price-wrapper">
                  <template v-if="classinfo.democlass=='1'">
                    <span class="actualprice">免费</span>
                    <span class="totalprice">¥{{classinfo.totalprice}}</span>
                  </template>
                  <template v-if="classinfo.democlass=='0'">
                    <span class="actualprice red">¥{{classinfo.actualprice}}</span>
                    <span class="totalprice" v-if="classinfo.discount!=0">¥{{classinfo.totalprice}}</span>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class="right">
            <p class="heading">班级信息</p>
            <p class="classname">
              {{decodeURIComponent(classinfo.classmodename)}}-{{decodeURIComponent(classinfo.classname)}}</p>
            <p class="time">开课时间：
              {{enrolldate}}
              <template v-if="classinfo&&classinfo.democlass=='0'">{{classinfo.starttime.substring(0, 5)}}</template>
              <template v-else>{{starttime}}</template>

            </p>
            <p class="num">共{{classinfo.totalnumber}}课；{{decodeURIComponent(classinfo.classperiodname)}}</p>
          </div>
        </div>
        <!--<div class="couponsection-wrapper">-->
        <!--<div class="coupontitle-wrapper">-->
        <!--<span class="coupontitle-left">使用优惠券</span>-->
        <!--<span class="coupontitle-middle" v-if="isEmpty(couponList)">暂无优惠券</span>-->
        <!--<span class="coupontitle-right">如何获取优惠券？</span>-->
        <!--<div class="hint">优惠券共有三种类型的票券：网校优惠券、课程优惠券和班级优惠券。主要有网校管理员或课程老师通过微信或其他平台分享发放得到。</div>-->
        <!--</div>-->
        <!--<div class="couponList-wrapper">-->
        <!--<template v-for="(item,index) in couponList" v-if="!isEmpty(couponList)">-->
        <!--<div class="list" :class="{now:item.show}" @click="changeItem(item)">-->
        <!--<p>-->
        <!--<span v-if="item.isClass" class="class">班</span>-->
        <!--<span v-else-if="item.isLesson" class="lesson">课</span>-->
        <!--<span v-else-if="item.isSchool" class="school">校</span>-->

        <!--<span>{{item.name}}</span>-->
        <!--</p>-->
        <!--</div>-->
        <!--</template>-->
        <!--</div>-->
        <!--</div>-->
        <p class="heading">支付方式<span class="more">当前仅支持使用支付宝支付</span></p>
        <div class="purchaseList-wrapper">
          <template v-for="(item,index) in purchaseList">
            <div class="list" :class="{now:item.show}">{{item.name}}</div>
          </template>

        </div>
        <div class="pricesection-wrapper" v-if="classinfo">
          <div class="priceinfo-wrapper">
            <p class="row">
              <span class="left">课程金额</span>
              <span class="right">¥{{classinfo.totalprice}}</span>
            </p>
            <p class="row" v-if="classinfo.democlass=='1'">
              <span class="left">试听价</span>
              <span class="right">¥0</span>
            </p>
            <p class="row" v-if="classinfo.democlass=='0'&&classinfo.discount!==0">
              <span class="left">活动价</span>
              <span class="right">¥{{classinfo.actualprice}}</span>
            </p>
            <p class="row" v-if="couponShow">
              <span class="left red">优惠抵用券</span>
              <span class="right">-¥
                <template v-for="item in couponList" v-if="item.show">{{item.discountmoney}}</template>
              </span>
            </p>
            <p class="totoalprice-row">
              <span class="left">应付金额：</span>
              <span class="right">¥{{totalprice}}</span>
            </p>
            <button class="purchaseBtn" @click="purchase()">提交订单</button>
          </div>
        </div>
      </div>
    </div>
    <foot-nav></foot-nav>
  </div>
</template>

<script type="text/ecmascript-6">
  import footNav from 'components/footnav/FootNav'
  import {saveLocal, loadLocal} from 'common/js/store.js';
  import globalNav from 'components/globalnav/GlobalNav'
  export default{
    data(){
      return {
        id: (() => loadLocal('id', false))(),
        userinfo: (() => loadLocal('userinfo', false))(),
        courseinfo: null,
        classinfo: null,
        enrolldate: '',
        starttime:null,
        endtime:null,
        username:null,
        imgprefix: (() => loadLocal('imgprefix', false))(),
        //---------------优惠券列表-----------//
        couponList: [],
        //---------------购买列表----------------//
        purchaseList: [{name: '支付宝', show: true}],
      }
    },
    methods: {
      isEmpty(obj){
        let t;
        for (t in obj) {
          return !1;
        }
        return !0;
      },
      //更改优惠券
      changeItem(item){
        this.couponList.forEach(function (ele) {
          ele.show = false;
        });
        item.show = true;
        this.$forceUpdate();
      },
      //查询指定一门课程
      QueryOneLesson(rid, lessonid){
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'Lesson',
            a: 'QueryOneLesson',
            id: this.id,
            rid: rid,
            lessonid: lessonid,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.imgprefix = response.imgprefix;
            this.courseinfo = response.list[0];
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      },
      //查询班级
      QueryClass(rid, lessonid, classid){
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'Lesson',
            a: 'QueryClass',
            id: this.id,
            rid: rid,
            lessonid: lessonid,
            classid: classid,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.imgprefix = response.imgprefix;
            this.classinfo = response.list[0];
            //班级为收费科时，才获取优惠券
//            if (this.classinfo.democlass == '0') {
//              this.QueryOrderClassDiscountCodes(rid, lessonid, classid);
//            }
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      },
      purchase(){
        if (this.courseinfo == null || this.classinfo == null) {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
          return;
        }
        const loading = this.$loading({
          lock: true,
          text: '购买中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        let lessonid = this.courseinfo.id;
        let rid = this.classinfo.rid;
        let classid = this.classinfo.id;
        let id = this.id;
        let url;
        //如果是试听课
        if (this.classinfo.democlass == '1') {
          let startDate = this.enrolldate;
          let startTime = startDate + ' ' + this.starttime;
          let endTime = startDate + ' ' + this.endtime;
          this.$http({
            url: '/indexapp.php',
            method: 'GET',
            params: {
              c: 'Unipay',
              a: 'OrderClass',
              id: id,
              rid: rid,
              lessonid: lessonid,
              classid: classid,
              planstarttime: startTime,
              planendtime: endTime,
              username:this.username,
            }
          }).then((response) => {
            response = response.data;
            if (response.code === 111) {
              this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
              return;
            }
            if (response.success === false) {
              loading.close();
              this.$alert(response.msg, '提示', {
                confirmButtonText: '确定',
              });
            }
            if (response.code === 200) {
              loading.close();
              this.$router.push('/success');
            }
          }).catch((err) => {
            loading.close();
            this.$alert('未获取到数据，请重新加载页面', '提示', {
              confirmButtonText: '刷新',
              callback: action => {
                window.location.reload();
              }
            });
          });
          return;
        } else if (this.classinfo.democlass == '0') {
          let startDate = this.enrolldate;
          let startTime = startDate + ' ' + this.classinfo.starttime.substring(0, 5);
          let endTime = startDate + ' ' + this.classinfo.endtime.substring(0, 5);
          let username = this.username;
          url = `${this.GLOBAL.buyUrl}indexapp.php?c=Unipay&a=OrderAlipayPage&lessonid=${lessonid}&rid=${rid}&classid=${classid}&id=${id}&planstarttime=${startTime}&planendtime=${endTime}&username=${username}&sucessurl=%2Fsuccess&failurl=%2Ffail`;
          for (let i = 0; i < this.couponList.length; i++) {
            if (this.couponList[i].show === true && this.couponList[i].discountmoney !== undefined) {
              url += '&discountcode=' + this.couponList[i].code;
            }
          }
        }
        window.location.href = url;
      },
      QueryOrderClassDiscountCodes(rid, lessonid, classid){
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'DiscountCode',
            a: 'QueryOrderClassDiscountCodes',
            id: this.id,
            rid: rid,
            lessonid: lessonid,
            classid: classid,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            let list = response.list;
            list.forEach(function (ele) {
              ele.isSchool = 0;
              ele.isLesson = 0;
              ele.isClass = 0;
              ele.show = false;
              if (ele.classid !== 0) {
                ele.isClass = 1;
              } else if (ele.lessonid !== 0) {
                ele.isLesson = 1;
              } else {
                ele.isSchool = 1;
              }
              ele.name = ele.discountmoney + '元券';

            });
            let noCoupon = {
              name: '不使用券',
              isSchool: 0,
              isLesson: 0,
              isClass: 0,
              show: true,
            };
            list.unshift(noCoupon);
            this.couponList = list;
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      },
    },
    computed: {
      couponShow(){
//        if (this.isEmpty(this.couponList)) {
//          return false;
//        } else {
//          for (let i = 0; i < this.couponList.length; i++) {
//            if (this.couponList[i].show === true && this.couponList[i].discountmoney !== undefined) {
//              return true;
//            }
//          }
//        }
        return false;
      },
      //计算总价格
      totalprice(){
        //如果是试听课，则返回0
        if (this.classinfo.democlass === '1') {
          return 0;
        } else {
          let actualprice = this.classinfo.actualprice;
//          for (let i = 0; i < this.couponList.length; i++) {
//            if (this.couponList[i].show === true && this.couponList[i].discountmoney !== undefined) {
//              actualprice = actualprice - this.couponList[i].discountmoney;
//              if (actualprice <= 0) {
//                actualprice = 0;
//              }
//            }
//          }
          return actualprice.toFixed(2);
        }
      }
    },
    created(){
      function getUrlKey2(name) {
        //根据url切换成array
        let urlArray = decodeURIComponent(String(window.location)).split('/');
        let index = urlArray.indexOf(name);
        let result = urlArray[index + 1];
        if (result === '') {
          return null;
        } else {
          return result;
        }
      }

      function getUrl() {
        let url = decodeURIComponent(String(window.location));
        let start = url.indexOf('#') + 1;
        return url.substring(start);
      }

      let rid = getUrlKey2("purchase?rid");
      let lessonid = getUrlKey2("lessonid");
      let classid = getUrlKey2("classid");
      this.enrolldate = getUrlKey2("enrolldate");
      this.starttime = getUrlKey2("starttime");
      this.endtime = getUrlKey2("endtime");
      this.username = getUrlKey2("username");
      if (this.id == false) {
        this.$router.push({path: '/log', query: {url: getUrl()}});
        return;
      }
      this.QueryOneLesson(rid, lessonid);
      this.QueryClass(rid, lessonid, classid);

    },
    components: {
      globalNav,
      footNav
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .purchase
    padding-top: 60px
    background: #fff
    .content-wrapper
      margin: 50px auto
      width: 1000px
      border: 1px solid #e4e4e4
      padding: 50px 75px 100px 50px
      box-sizing border-box
      overflow hidden
      .title
        font-size: 24px
        color: #000000
        font-weight: bold
        line-height: 38px
      .info-wrapper
        padding: 55px 0 0 25px
        .heading
          margin-bottom: 20px
          font-size: 14px
          color: #000000
          font-weight: bold
          line-height: 18px
          .more
            margin-left: 15px
            font-size: 13px
            color: #999
        .userinfo
          margin-bottom: 40px
          padding-left: 20px
          height: 50px
          line-height 50px
          background #f2f2f2
          .text
            font-size: 14px
            color: #555555

        .classinfo-wrapper
          margin-bottom: 40px
          padding: 20px 0 20px 20px
          background #f2f2f2
          font-size: 0
          .left
            display: inline-block
            padding-bottom: 10px
            width: 405px
            border-right: 2px dashed #e4e4e4
            box-sizing: border-box
            vertical-align top
            .heading
              margin-bottom: 30px
              line-height: 20px
              font-size: 15px
              color: #000
            .img-wrapper
              img
                vertical-align top
              .courseinfo-wrapper
                display inline-block
                margin-left: 10px
                width: 270px
                .heading
                  font-size: 14px
                  color: #000000
                  font-weight: bold
                  line-height: 20px
                  overflow hidden
                  text-overflow ellipsis
                  white-space nowrap
                  margin: 0
                .type
                  margin: 18px 0 6px
                  font-size: 12px
                  color: #999999
                .price-wrapper
                  height: 20px
                  line-height: 20px
                  .actualprice
                    font-size: 16px
                    color: #00cc00
                    &.red
                      color: red
                  .totalprice
                    margin-left: 15px
                    font-size: 12px
                    color: #999
                    text-decoration: line-through

          .right
            display: inline-block
            padding-left: 30px
            width: 405px
            box-sizing border-box
            .heading
              font-size: 15px
              color: #000
            .classname
              margin: 30px 0 16px
              line-height: 22px
              font-size: 16px
              color: #000000
              font-weight: bold
            .time, .num
              line-height: 18px
              font-size: 13px
              color: #888888
              margin-bottom: 6px
            .num
              margin: 0

        .couponsection-wrapper
          margin-bottom: 20px
          padding-bottom: 20px
          border-bottom: 1px solid #e4e4e4
          .coupontitle-wrapper
            height: 18px
            position relative
            .coupontitle-left
              font-size: 14px
              color: #000000
              font-weight: bold
            .coupontitle-middle
              margin-left: 15px
              font-size: 13px
              color: #999999
            .coupontitle-right
              float: right
              font-size: 12px
              color: #999999
              cursor pointer
              &:hover + .hint
                display: block
            .hint
              display none
              position absolute
              right: 0
              top: 18px
              padding: 14px
              width: 200px
              font-size: 12px
              color: #555555
              line-height: 18px
              background #fff
              border: 1px solid #e4e4e4
          .couponList-wrapper
            padding: 20px 0 0 20px
            .list
              display: inline-block
              margin: 0 10px 0 0
              height: 34px
              width: 130px
              line-height: 32px
              text-align: center
              font-size: 13px
              color: #666
              border: 1px solid #e4e4e4
              box-sizing border-box
              cursor pointer
              &.now
                border: 2px solid #3399ff
                line-height: 30px
                background: #fff url('./selected.png') no-repeat right bottom / 20px 20px
              .school, .lesson, .class
                margin-right: 18px
                display: inline-block
                width: 20px
                height: 20px
                color: #ffffff
                border-radius 20px
                line-height: 20px
              .school
                background #ff978b
              .lesson
                background #3399ff
              .class
                background #8787ff
        .purchaseList-wrapper
          padding: 20px 20px 60px
          border-bottom: 1px solid #e4e4e4
          .list
            display: inline-block
            margin: 0 10px 0 0
            height: 34px
            width: 110px
            line-height: 32px
            text-align: center
            font-size: 13px
            color: #666
            border: 1px solid #e4e4e4
            box-sizing border-box
            cursor pointer
            &.now
              border: 2px solid #3399ff
              line-height: 30px
              background: #fff url('./selected.png') no-repeat right bottom / 20px 20px
        .pricesection-wrapper
          padding-top: 40px
          .priceinfo-wrapper
            float: right
            text-align right
            .row
              margin-bottom: 20px
              line-height: 18px
              color: #666666
              font-size: 13px
              .left
                text-align: right
                &.red
                  color: #ff6666
              .right
                display inline-block
                width: 140px
                text-align: right

            .totoalprice-row
              margin-bottom: 30px
              line-height: 32px
              .left
                color: #333
                font-size: 16px
                text-align: right
                &.red
                  color: #ff6666
              .right
                display inline-block
                width: 140px
                text-align: right
                font-size: 24px
                color: red
            .purchaseBtn
              margin-top: 30px
              display inline-block
              width: 150px
              height: 50px
              line-height 50px
              text-align center
              font-size: 20px
              color: #ffffff
              border-radius 4px
              background #3399ff
</style>



// WEBPACK FOOTER //
// src/page/purchase/Purchase.vue